import React, { Fragment } from "react";

import Header from "../common/layout/Header";
import SubHeader from "../common/layout/SubHeader";
import HeroHome from "./sections/HeroHome";
import PlatformHome from "./sections/PlatformHome";
import SolutionHome from "./sections/SolutionHome";
import AcceptHome from "./sections/AcceptHome";
import AcceptCelHome from "./sections/AcceptCelHome";
import IntegralSolutionHome from "./sections/IntegralSolutionHome";
import ContactForm from "components/common/ContactForm";
import Footer from "../common/layout/Footer";

const HomeScreen = () => {
  return (
    <Fragment>
      <Header inverse />
      <SubHeader inverse />
      <HeroHome />
      <PlatformHome />
      <SolutionHome />
      <AcceptHome />
      <AcceptCelHome />
      <IntegralSolutionHome />
      <ContactForm />
    {/* 
    //   <OurClientsHome />
    //   <ContactHome />
    //    */}
      <Footer />
    </Fragment>
  );
};

export default HomeScreen;
